import { createRegistry } from '../createRegistry';
const registry = createRegistry({
    host: 'thunderboltPreview',
});
export default registry;
export { registry };
export * from '../types';
//# sourceMappingURL=preview.js.map